export default "__VITE_ASSET__BmPNXhro__"